export default {"src":"https://dap-prod-3m8r9mc2a-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};